export default __webpack_public_path__ + "bef0b072cbd517f3d58189eea8313a4b.svg";